import { NavLink } from 'react-router-dom';
import { useStore } from '../../app/stores/store';
import { useLegacyMode } from './LegacyModeContext';
import { nativeNavigation } from '../../app/layout/nativeNavigation';
import { getCachedFitmentCatalogLabel } from '../../app/utils/fitmentCatalogLabel';
import { isProductGuideEnabledForCurrentContext } from '../../app/utils/productGuideFeature';
import { isServiceBookingEnabledForShop } from '../../app/utils/serviceBookingFeature';
import { observer } from 'mobx-react-lite';

export default observer(function OperatorNavigation() {
  const { userStore } = useStore();
  const { loading, isLegacy } = useLegacyMode();
  if (!userStore.user?.impersonation || loading || isLegacy) return null;
  const shop = userStore.user.shopDomain;
  return <nav aria-label="Merchant app navigation" className="LegacyTopNav"><ul className="LegacyTopNav__list">
    {nativeNavigation(getCachedFitmentCatalogLabel(), isProductGuideEnabledForCurrentContext(shop), isServiceBookingEnabledForShop(shop)).map(link =>
      <li key={link.to} className="LegacyTopNav__item"><NavLink to={link.to}
        className={({ isActive }) => `LegacyTopNav__link${isActive ? ' LegacyTopNav__link--active' : ''}`}>{link.label}</NavLink></li>)}
  </ul></nav>;
});
